import { useContext, useEffect } from 'react'
import { useForm } from 'react-hook-form'

import { PageContext } from '@pages/MapCreateOrEdit/MapCreateOrEdit'
import { MapSettingsFormValues } from '@pages/MapCreateOrEdit/types'

import { useHandlers } from './useHandlers'
import { useInputs } from './useInputs'

const getDefaultValues = (): MapSettingsFormValues => ({
  center: {
    latitude: 0,
    longitude: 0,
  },
  maxBounds: {
    swLatitude: 0,
    swLongitude: 0,
    neLatitude: 0,
    neLongitude: 0,
  },
  zoom: 10,
})

export const useMapSettingsDialog = () => {
  const { mapSettingsDialogData } = useContext(PageContext)

  const methods = useForm<MapSettingsFormValues>({ defaultValues: getDefaultValues() })

  const {
    reset,
    formState: { isDirty },
  } = methods

  useEffect(() => {
    if (mapSettingsDialogData?.mapSettings) {
      reset(mapSettingsDialogData.mapSettings)
    }
  }, [mapSettingsDialogData, reset])

  const handlers = useHandlers({ methods })
  const inputs = useInputs()

  return {
    state: {
      methods,
      isDirty,
      isOpen: Boolean(mapSettingsDialogData),
    },
    handlers,
    inputs,
  }
}
